import { render, staticRenderFns } from "./BvBadge.vue?vue&type=template&id=82d2f7c8&"
import script from "./BvBadge.vue?vue&type=script&lang=ts&"
export * from "./BvBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports